import { jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
const variants = {
  sm: "14_18_700",
  md: "14_18_700",
  lg: "16_20_700"
}, Label = ({ disabled, children, htmlFor, size = "md", ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    variant: variants[size],
    component: "label",
    htmlFor,
    sx: {
      lineHeight: "20px",
      minWidth: 10,
      color: disabled ? "grey.400" : "text.primary"
    },
    ...props,
    children
  }
);
export {
  Label
};
//# sourceMappingURL=Label.js.map
